import { css } from '@emotion/react'
import { Fade, Tooltip } from '@mui/material'
import { memo } from 'react'
import IconButton from '../../../Buttons/IconButton'
import { getThemeSpacing } from '../../../styles/appTheme'

export const EMOTICON_HEIGHT = 44
export const EMOTICON_WIDTH = EMOTICON_HEIGHT

// the Tooltip is at the root of the body tag now instead of contained within
// const EmoticonTooltip = styled(Tooltip)({
//     // '& .MuiTooltip-popper': {
//     //     zIndex: PAPER_HEIGHTS.emoticon,
//     // },
//     // '& .MuiTooltip-tooltip': {
//     //     position: 'relative',
//     //     bottom: '-1rem',
//     //     border: '1px solid #dadde9',
//     //     color: palette.commonWhite,
//     //     // fontSize: '1.5rem', //theme.typography.pxToRem(12),
//     //     fontWeight: 'bold',
//     //     maxWidth: 220,
//     //     opacity: 0.9,
//     // },
// })

const buttonContainerStyles = css({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
})
const buttonStyles = css({
    border: 0,
    padding: getThemeSpacing(3.5),
    height: EMOTICON_HEIGHT,
    width: EMOTICON_WIDTH,
})

interface ItemData {
    id: number
    key: string
}
interface IEmoticon {
    itemData?: ItemData
    darkMode?: boolean
    onClickEmoticon(key: string): void
}

const Emoticon = memo((props: IEmoticon) => {
    const { itemData, darkMode, onClickEmoticon } = props

    if (!itemData) return null

    const { key, id } = itemData

    const handleOnClick = () => onClickEmoticon(key)

    const path = darkMode ? 'chat_images/e/dark' : 'chat_images/e'
    const imgSrc = `https://img.mfcimg.com/${path}/${id}.gif`

    return (
        <Tooltip
            disableFocusListener
            disableTouchListener
            enterDelay={250}
            placement="top"
            title={key}
            TransitionComponent={Fade}
        >
            <div css={buttonContainerStyles} key={key}>
                <IconButton
                    css={[buttonStyles]}
                    onClick={handleOnClick}
                    title={key}
                >
                    <img src={imgSrc} />
                </IconButton>
            </div>
        </Tooltip>
    )
})

export default Emoticon
